import './FlavorProduct.scss';
import Component from './FlavorProduct.js';
export default Component;
